import { useMemo } from "react";

import { StatusRefund } from "@/lib/gql/__generated__/graphql";

import { EditGuideTooltip } from "@/components/features/items/edit/_shared/ui/components/system/tooltip/edit-guide-tooltip";

import { Label } from "@/components/ui/label/label";

type Props = {
	statusRefund?: StatusRefund | null;
	refundedPriceByAdmin: number;
	totalGuestCharge: number;
};

export const RefundStatusAfterStayOfManagementStatusCompositions = ({
	statusRefund,
	refundedPriceByAdmin,
	totalGuestCharge,
}: Props) => {
	/**
	 * 返金された金額が存在するか
	 */
	const existRefundedPrice = useMemo(() => {
		return refundedPriceByAdmin > 0;
	}, [refundedPriceByAdmin]);

	const canShow = useMemo(() => {
		return statusRefund === StatusRefund.Approval && existRefundedPrice;
	}, [existRefundedPrice, statusRefund]);

	const isTotallyRefunded = useMemo(() => {
		return refundedPriceByAdmin >= totalGuestCharge;
	}, [refundedPriceByAdmin, totalGuestCharge]);

	const isPartiallyRefunded = useMemo(() => {
		return refundedPriceByAdmin < totalGuestCharge;
	}, [refundedPriceByAdmin, totalGuestCharge]);

	return (
		canShow && (
			<div className="w-full space-y-2">
				<div className="flex items-center gap-2">
					<p>宿泊後の返金</p>

					<EditGuideTooltip
						guide="
					<b>宿泊後の返金とは？</b>
					<br />
					<br />
					<p>貴社からのご要望を受けて、</p>
					<p>CHILLNNからお客様に対して行われた返金に関するステータスです。</p>
					返金した結果、締め日での収支合計がマイナスになってしまう場合には、
					<p>CHILLNNから請求書を発行させていただきます。</p>
        "
					/>
				</div>

				<div className="flex flex-wrap gap-2">
					<Label text="全額返金済み" variant={isTotallyRefunded ? "pink" : "black"} />

					<Label text="部分的に返金済み" variant={isPartiallyRefunded ? "pink" : "black"} />
				</div>
			</div>
		)
	);
};
